







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  inheritAttrs: true
})
export default class ButtonBack extends Vue {
	@Prop() private readonly goBack: Function;
}
